import {Component, ViewChild, ElementRef} from '@angular/core';
import {IonicPage, AlertController, NavParams, ViewController, ModalController} from 'ionic-angular';
import {
    HomogenizationOrderApi, HomogenizationOrderInLineApi, HomogenizationOrderOutLineApi,
    PartnerApi, ProductApi,
    StockLocationApi,
    StockWarehouseLocationApi
} from "../../sdk";
import {HomogenizationOrder, HomogenizationOrderInLine, HomogenizationOrderOutLine} from '../../sdk';
import {BaseViewComponent} from '../../components/baseViewComponent';
import {LoadingComponent} from '../../components/loadingComponent';
import {LoopBackAuth} from "../../sdk";
import {StorageCacheProvider} from "../../providers/storage-cache-provider";
import {ServerProvider} from "../../providers/server-provider";
import {IPartner} from "../../models";
import {IStockLocation} from "../../models/iStockLocation";
import {IUsers} from "../../models/iUsers";
import {IProduct} from "../../models/iProduct";
import {Observable} from "rxjs";
import {defaultIfEmpty} from "rxjs/operators";
import {IHomogenizationOrder} from "../../models/IHomogenizationOrder";

@IonicPage({
    segment: 'homogenization-order-add',
    name: 'HomogenizationOrderAddPage'
})
@Component({
    selector: 'page-homogenization-order-add',
    templateUrl: 'homogenization-order-add.html',
})
export class HomogenizationOrderAddPage extends BaseViewComponent {

    @ViewChild('noteTextArea') noteTextArea: ElementRef;

    public createOrder: HomogenizationOrder;
    public editOrder: HomogenizationOrder;
    public createInLines: Array<HomogenizationOrderInLine>;
    public createOutLines: Array<HomogenizationOrderOutLine>
    public isModeCreate: boolean = true;
    public isOpenModal: boolean = false;
    public isModeReadOnly: boolean = false;
    private myCurrentUser: IUsers;

    constructor(
        public alertCtrl: AlertController,
        public params: NavParams,
        public homogenizationOrderService: HomogenizationOrderApi,
        public homogenizationOrderOutLineService: HomogenizationOrderOutLineApi,
        public homogenizationOrderInLineService: HomogenizationOrderInLineApi,
        public partnerService: PartnerApi,
        public viewCtrl: ViewController,
        public loading: LoadingComponent,
        public modalCtrl: ModalController,
        public authService: LoopBackAuth,
        public stockWarehouseLocationService: StockWarehouseLocationApi,
        public stockLocationService: StockLocationApi,
        public productService: ProductApi,
        private storageCache: StorageCacheProvider,
    ) {
        super();
        this.createOrder = new HomogenizationOrder();
        this.createInLines = new Array<HomogenizationOrderInLine>();
        this.createOutLines = new Array<HomogenizationOrderOutLine>();
    }


    ionViewDidLoad() {
        super.ionViewDidLoad();
        this.editOrder = this.params.get("edit");
        if (this.editOrder && this.editOrder.id) {
            this.createOrder = JSON.parse(JSON.stringify(this.editOrder));
            this.createInLines = this.createOrder.inLines
            this.createOutLines = this.createOrder.outLines
            this.isModeCreate = false;
            this.isModeReadOnly = (this.editOrder.state == 'done');
        } else {
            this.isModeCreate = true;
            this.isModeReadOnly = false;
            this.myCurrentUser = ServerProvider.myApp.userLogin;
            this.setDefaults()
        }
    }

    public setDefaults(): void {
        this.createOrder.user = this.myCurrentUser;
        this.createOrder.user_id = this.myCurrentUser.id
        if (!this.createOrder.company && this.myCurrentUser && this.myCurrentUser.myCompany) {
            this.createOrder.company = this.myCurrentUser.myCompany;
            this.createOrder.company_id = this.myCurrentUser.myCompany.id
        }
        if (this.myCurrentUser.wcpLocation) {
            this.createOrder.warehouseLocation = this.myCurrentUser.wcpLocation
            this.createOrder.warehouse_location_id = this.myCurrentUser.wcp_location
        }
    }

    public getWarehouseLocation(): string {
        if (this.createOrder && this.createOrder.warehouseLocation) {
            return this.createOrder.warehouseLocation.name
        }
        return "";
    }

    public selectWarehouseLocation() {
        if (!this.isOpenModal && !this.isModeReadOnly) {

            //loading mensaje
            this.loading.create({content: 'Cargando almacenes de salida', showBackdrop: false});

            //obtenemos los stockWarehouseLocation de caches
            this.storageCache.getDataCache(
                StorageCacheProvider.STORAGE_KEYS.STOCK_WAREHOUSE_LOCATIONS,
                this.stockWarehouseLocationService,
                {}
            ).then(data => {
                this.loading.dismiss();

                if (data && data.length > 0) {
                    //Abrir modal
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: this.createOrder.warehouseLocation ? this.createOrder.warehouseLocation.name : "",
                        listItems: data
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            //seleccionamos el warhouse
                            this.createOrder.warehouseLocation = data;
                            this.createOrder.warehouse_location_id = data.warehouse_id;
                            this.createOrder.location_id = data.stock_location_id;
                            this.createOrder.warehouse_location_id = data.id;
                        }
                        this.isOpenModal = false;
                    });

                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ningún almacén disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getPartner(): string {
        if (this.createOrder && this.createOrder.partner) {
            return this.createOrder.partner.name
        }
        return "";
    }

    public selectPartner(): void {
        if (!this.isOpenModal && !this.isModeReadOnly) {

            //loading mensaje
            this.loading.create({content: 'Cargando proveedores', showBackdrop: false});

            //consulta los partners para los purchase add de tipo residue
            this.partnerService.get_valid_residue_partner_ids(null, ServerProvider.getCustomHeaders).subscribe(success => {

                if (success && success.length > 0) {

                    ServerProvider.find(this.partnerService, {
                        fields: IPartner.FIELDS,
                        include: IPartner.FILTER_INCLUDE_LER_PRODUCTS,
                        where: {
                            id: success
                        }
                    }, true).subscribe(listResiduePartners => {

                        this.loading.dismiss();
                        this.selectPartnerOpenModal(listResiduePartners);

                    });

                } else {
                    //no hay partners
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ningún proveedor disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    private selectPartnerOpenModal(listResiduePartners) {
        //Abrir modal
        let modal = this.modalCtrl.create('CustomSelectorPage', {
            strSearchBar: this.createOrder.partner ? this.createOrder.partner.name : "",
            listItems: listResiduePartners
        });
        this.isOpenModal = true;
        modal.present();
        modal.onWillDismiss(data => {
            if (data && data.name) {
                this.createOrder.partner = data;
                this.createOrder.partner_id = data.id;
            }
            this.isOpenModal = false;
        });
    }

    public getProduct(): string {
        if (this.createOrder && this.createOrder.product) {
            return this.createOrder.product.name;
        }
        return "";
    }

    public selectProduct() {
        if (!this.isOpenModal && !this.isModeReadOnly) {
            this.loading.create({content: 'Cargando productos', showBackdrop: false});
            ServerProvider.find(this.productService, {
                fields: IProduct.FIELDS,
                include: IProduct.FILTER_INCLUDE
            }, true).subscribe(products => {
                if (products && products.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: "",
                        listItems: products
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createOrder.product = data;
                            this.createOrder.product_id = data.id;
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ningún producto disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getLocation(): string {
        if (this.createOrder && this.createOrder.location) {
            return this.createOrder.location.name;
        }
        return "";
    }

    public selectLocation(): void {
        if (!this.isOpenModal && !this.isModeReadOnly) {
            this.loading.create({content: 'Cargando localizaciones', showBackdrop: false});
            ServerProvider.find(this.stockLocationService, {
                fields: IStockLocation.FIELDS,
                include: IStockLocation.FILTER_INCLUDE
            }, true).subscribe(locations => {
                if (locations && locations.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: this.createOrder.location ? this.createOrder.location.name : "",
                        listItems: locations
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createOrder.location = data;
                            this.createOrder.location_id = data.id;
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ninguna localización disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getProductionLocation(): string {
        if (this.createOrder && this.createOrder.productionLocation) {
            return this.createOrder.productionLocation.name;
        }
        return "";
    }

    public selectProductionLocation(): void {
        if (!this.isOpenModal && !this.isModeReadOnly) {
            this.loading.create({content: 'Cargando localizaciones', showBackdrop: false});
            ServerProvider.find(this.stockLocationService, {
                fields: IStockLocation.FIELDS,
                include: IStockLocation.FILTER_INCLUDE
            }, true).subscribe(locations => {
                if (locations && locations.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: this.createOrder.productionLocation ? this.createOrder.productionLocation.name : "",
                        listItems: locations
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createOrder.productionLocation = data;
                            this.createOrder.production_location_id = data.id;
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ninguna localización disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getNoQualityLocation(): string {
        if (this.createOrder && this.createOrder.noQualityLocation) {
            return this.createOrder.noQualityLocation.name;
        }
        return "";
    }

    public selectNoQualityLocation(): void {
        if (!this.isOpenModal && !this.isModeReadOnly) {
            this.loading.create({content: 'Cargando localizaciones', showBackdrop: false});
            ServerProvider.find(this.stockLocationService, {
                fields: IStockLocation.FIELDS,
                include: IStockLocation.FILTER_INCLUDE
            }, true).subscribe(locations => {
                if (locations && locations.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: this.createOrder.noQualityLocation ? this.createOrder.noQualityLocation.name : "",
                        listItems: locations
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createOrder.noQualityLocation = data;
                            this.createOrder.no_quality_location_id = data.id;
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ninguna localización disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getLocationDest(): string {
        if (this.createOrder && this.createOrder.locationDest) {
            return this.createOrder.locationDest.name;
        }
        return "";
    }

    public selectLocationDest(): void {
        if (!this.isOpenModal && !this.isModeReadOnly) {
            this.loading.create({content: 'Cargando localizaciones', showBackdrop: false});
            ServerProvider.find(this.stockLocationService, {
                fields: IStockLocation.FIELDS,
                include: IStockLocation.FILTER_INCLUDE
            }, true).subscribe(locations => {
                if (locations && locations.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: this.createOrder.locationDest ? this.createOrder.locationDest.name : "",
                        listItems: locations
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createOrder.locationDest = data;
                            this.createOrder.location_dest_id = data.id;
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ninguna localización disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getDatePlannedStart(): string {
        if (this.createOrder && this.createOrder.date_planned_start) {
        }
        return "-";
    }

    public selectDatePlannedStart(): void {
        return
    }

    public getDateDone(): string {
        if (this.createOrder && this.createOrder.date_done) {
        }
        return "-";
    }

    public selectDateDone(): void {
        return
    }

    public getCompany(): string {
        if (this.createOrder && this.createOrder.company) {
            return this.createOrder.company.name;
        }
        return "";
    }

    public selectCompany(): void {
        return
    }

    public getUser(): string {
        if (this.createOrder && this.createOrder.user) {
            return this.createOrder.user.name;
        }
        return "";
    }

    public selectUser(): void {
        return
    }

    public getProductInLine(id: number): string {
        if (this.createInLines[id].product) {
            return this.createInLines[id].product.name;
        }
        return "";
    }

    public selectProductInLine(id: number): void {
        if (!this.isOpenModal && !this.isModeReadOnly) {
            this.loading.create({content: 'Cargando productos', showBackdrop: false});
            ServerProvider.find(this.productService, {
                fields: IProduct.FIELDS,
                include: IProduct.FILTER_INCLUDE
            }, true).subscribe(products => {
                if (products && products.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: "",
                        listItems: products
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createInLines[id].product = data;
                            this.createInLines[id].product_id = data.id;
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ningún producto disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getProductInLineUOMName(id: number): String {
        if (this.createInLines[id] && this.createInLines[id].product && this.createInLines[id].productUom) {
            return this.createInLines[id].productUom.name;
        }
        return null;
    }

    public getLocationInLine(id: number) {
        if (this.createInLines[id] && this.createInLines[id].location) {
            return this.createInLines[id].location.name;
        }
        return "-"
    }

    public selectLocationInLine(id: number) {
        return
    }

    public getLocationDestInLine(id: number): string {
        if (this.createInLines && this.createInLines[id].locationDest) {
            return this.createInLines[id].locationDest.name;
        }
        return "-";
    }

    public selectLocationDestInLine(id: number) {
        return
    }

    public getPackageInLine(id: number): string {
        if (this.createInLines && this.createInLines[id].package) {
            return this.createInLines[id].package.name;
        }
        return "-";
    }

    public selectPackageInLine(id: number): string {
        return;
    }

    public getProdLotInLine(id: number): string {
        if (this.createInLines && this.createInLines[id].prodLot) {
            return this.createInLines[id].prodLot.name;
        }
        return "-";
    }

    public selectProdLotInLine(id: number): string {
        return;
    }

    public getProductOutLine(id: number): string {
        if (this.createOutLines[id].product) {
            return this.createOutLines[id].product.name;
        }
        return "";
    }

    public selectProductOutLine(id: number): void {
        return
    }

    public getLocationDestOutLine(id: number): string {
        if (this.createOutLines[id].locationDest) {
            return this.createOutLines[id].locationDest.name;
        }
        return "";
    }

    public selectLocationDestOutLine(id: number): string {
        return
    }

    public getLocationOutLine(id: number): string {
        if (this.createOutLines[id].location) {
            return this.createOutLines[id].location.name;
        }
        return "";
    }

    public selectLocationOutLine(id: number): string {
        return
    }

    public getPackageOutLine(id: number): string {
        if (this.createOutLines[id].package) {
            return this.createOutLines[id].package.name;
        }
        return "";
    }

    public selectPackageOutLine(id: number): string {
        return;
    }

    public getProdLotOutLine(id: number): string {
        if (this.createOutLines[id].prodLot) {
            return this.createOutLines[id].prodLot.name;
        }
        return "";
    }

    public selectProdLotOutLine(id: number): string {
        return;
    }

    public getProductOutLineUOMName(id: number): String {
        if (this.createOutLines[id] && this.createOutLines[id].product && this.createOutLines[id].productUom) {
            return this.createOutLines[id].productUom.name;
        }
        return null;
    }

    public getTotalOutLinesQty() {
        let totalQty = 0;
        let uom = ""
        this.createOutLines.forEach(line => {
            totalQty += line.product_qty
            uom = line.productUom.name
        })
        return `${totalQty} ${uom}`;
    }

    public getTotalInLinesQty() {
        let totalQty = 0;
        let uom = ""
        this.createInLines.forEach(line => {
            totalQty += line.product_qty
            uom = line.productUom.name
        })
        return `${totalQty} ${uom}`;
    }

    public orderCreate() {
        this.loading.create({content: 'Creando pedido de homogenización', showBackdrop: false});
        ServerProvider.create(this.homogenizationOrderService, this.createOrder, true).subscribe(success => {
            if (success && success.id) {
                this.loading.dismiss();
                this.dismiss(true);
            }
        })
    }

    public orderSave() {
        this.loading.create({content: 'Guardando...', showBackdrop: false});
        let promiseList = new Array<Observable<any>>();
        if (this.createInLines.length > 0 && this.editOrder.inLines !== this.createInLines) {
            this.createInLines.forEach((line, idLine) => {
                promiseList.push(ServerProvider.createOrUpdate(this.homogenizationOrderInLineService, line));
            });
        }
        if (this.createOutLines.length > 0 && this.editOrder.outLines !== this.createOutLines) {
            this.createOutLines.forEach((line, idLine) => {
                promiseList.push(ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, line));
            });
        }
        if (this.editOrder !== this.createOrder) {
            delete this.createOrder.outLines
            delete this.createOrder.inLines
            delete this.createOrder.in_line_ids
            delete this.createOrder.out_line_ids
            promiseList.push(ServerProvider.update(this.homogenizationOrderService, this.createOrder))
        }
        if (promiseList.length > 0) {
            Observable.forkJoin(promiseList).pipe(defaultIfEmpty(null)).subscribe(success => {
                this.loading.dismiss();
                this.dismiss(true);
            });
        }
    }

    public getLotAndPackageOutLine(id: number) {
        this.loading.create({content: 'Asignando lote y paquete...', showBackdrop: false});
        ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, this.createOutLines[id]).subscribe(success => {
            this.homogenizationOrderOutLineService.get_lot_and_package(this.createOutLines[id].id, ServerProvider.getCustomHeaders).subscribe(success => {
                this.loading.dismiss();
                this.reloadOrder();
            }, error => {
                console.log(error)
                this.loading.dismiss();
                this.reloadOrder();
            })
        }, error => {
            this.loading.dismiss()
            console.log('Ha ocurrido un error.')
        })
    }

    public processOutLine(id: number) {
        this.loading.create({content: 'Procesando...', showBackdrop: false});
        ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, this.createOutLines[id]).subscribe(success => {
            this.homogenizationOrderOutLineService.process(this.createOutLines[id].id, ServerProvider.getCustomHeaders).subscribe(success => {
                this.loading.dismiss();
                if (success) {
                    this.loading.dismiss();
                    this.reloadOrder();
                }
            }, error => {
                this.loading.dismiss();
                this.dismiss(true);
            })
        }, error => {
            this.loading.dismiss()
            console.log('Ha ocurrido un error')
        })
    }

    public deleteInLine(id: number) {
        this.alertCtrl.create({
            title: '¿Quieres borrar esta línea?',
            buttons: [
                {
                    text: 'Aceptar',
                    handler: () => {
                        ServerProvider.deleteById(this.homogenizationOrderInLineService, this.createInLines[id].id).subscribe(success => {
                            this.reloadOrder()
                        })
                    }
                },
                {
                    text: 'Cancelar',
                }
            ]
        }).present();
        this.reloadOrder();
    }


    public deleteOutLine(id: number) {
        this.alertCtrl.create({
            title: '¿Quieres borrar esta línea?',
            buttons: [
                {
                    text: 'Aceptar',
                    handler: () => {
                        ServerProvider.deleteById(this.homogenizationOrderOutLineService, this.createOutLines[id].id).subscribe(success => {
                            this.reloadOrder()
                        })
                    }
                },
                {
                    text: 'Cancelar',
                }
            ]
        }).present();
        this.reloadOrder();
    }

    public printOutLine(id: number) {
        this.loading.create({content: 'Procesando...', showBackdrop: false});
        this.homogenizationOrderOutLineService.print_report_line_customer_app(this.createOutLines[id].id, ServerProvider.getCustomHeaders).subscribe(success => {
            this.loading.dismiss();
            this.alertCtrl.create({
                title: 'Ok',
                subTitle: 'Impresión enviada.',
                buttons: ['Aceptar']
            }).present();
        }, error => {
            this.loading.dismiss();
            console.log(error)
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'No se ha podido enviar la impresión.',
                buttons: ['Aceptar']
            }).present();
        })
    }

    public processInLine(id: number) {
        this.loading.create({content: 'Procesando...', showBackdrop: false});
        this.homogenizationOrderInLineService.process(this.createInLines[id].id, ServerProvider.getCustomHeaders).subscribe(success => {
            if (success) {
                this.loading.dismiss();
                this.reloadOrder();
            }
        }, error => {
            console.log(error)
            this.loading.dismiss();
            this.dismiss(true);
        })
    }

    public orderConfirm() {
        this.loading.create({content: 'Confirmando pedido de homogenización', showBackdrop: false});
        this.homogenizationOrderService.button_confirm(this.createOrder.id, ServerProvider.getCustomHeaders).subscribe(success => {
            this.loading.dismiss();
            if (success) {
                this.createOrder.state = "done";
                this.editOrder = this.createOrder;
                this.confirmRequestOk();
            }
        })
    }

    public orderDone() {
        this.loading.create({content: 'Marcando como hecho el pedido de homogenización', showBackdrop: false});
        this.homogenizationOrderService.button_done(this.createOrder.id, ServerProvider.getCustomHeaders).subscribe(success => {
            this.loading.dismiss();
            if (success) {
                this.reloadOrder()
                this.isModeReadOnly = true
            }
        })
    }

    private confirmRequestOk() {
        this.alertCtrl.create({
            title: 'Pedido de homogenización confirmado',
            buttons: [
                {
                    text: 'Aceptar',
                    handler: () => {
                        //volver al listado
                        this.dismiss(true);
                    }
                }
            ]
        }).present();
    }

    public addInline() {
        let modal = this.modalCtrl.create('HomogenizationOrderInlineAddPage', {order: this.createOrder}, {cssClass: "full-popover"});
        modal.present();
        modal.onWillDismiss(data => {
            if (data.reload) {
                this.reloadOrder()
            }
            if(data.new) {
                this.addInline()
            }
        });
    }

    public addOutline() {
        let modal = this.modalCtrl.create('HomogenizationOrderOutlineAddPage', {order: this.createOrder}, {cssClass: "full-popover"});
        modal.present();
        modal.onWillDismiss(data => {
            if (data) {
                this.reloadOrder()
            }
        });
    }

    public reloadOrder() {
        this.loading.create({content: 'Recopilando nueva información...', showBackdrop: false});
        ServerProvider.findById(this.homogenizationOrderService, this.createOrder.id, {
            fields: IHomogenizationOrder.FIELDS,
            include: IHomogenizationOrder.FILTER_INCLUDE
        }, false).subscribe(order => {
            if (order) {
                console.log(order)
                this.loading.dismiss();
                this.createOrder = JSON.parse(JSON.stringify(order));
                this.createInLines = this.createOrder.inLines
                this.createOutLines = this.createOrder.outLines
            }
        })
    }

    public dismiss(data = null) {
        this.viewCtrl.dismiss(data)
    }

    public resizeTextArea(event) {
        if (event && event.keyCode == 13) {
            var element = this.noteTextArea['_elementRef'].nativeElement.getElementsByClassName("text-input")[0];
            var scrollHeight = element.scrollHeight;
            element.style.height = scrollHeight + 'px';
            this.noteTextArea['_elementRef'].nativeElement.style.height = (scrollHeight + 16) + 'px';
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/homogenization-order-add/homogenization-order-add.ts